import { Diagnosis } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { SidePanelList, VisitPreviewIcon } from '@dreryk/react-components';

import { useDiagnosisSidePanelListItems } from './DiagnosisSidePanelList.hooks';

type DiagnosisSidePanelListProps = {
   readonly diagnosis: Diagnosis[];
   readonly patientId: number;
};

export const DiagnosisSidePanelList = (props: DiagnosisSidePanelListProps): JSX.Element => {
   return (
      <SidePanelList
         icon={<VisitPreviewIcon />}
         items={useDiagnosisSidePanelListItems(props.diagnosis, props.patientId)}
         noItemsMessage={createTranslatedText(null)}
      />
   );
};
